import { useCallback, useEffect, useRef, useState } from 'react';
import { useModal } from '.';

export const useConfirmModal = () => {
  const modal = useModal();
  const [confirmed, setConfirmed] = useState(false);
  const resolverRef = useRef<((value: boolean | PromiseLike<boolean>) => void) | null>(null);

  useEffect(() => {
    if (resolverRef.current) {
      resolverRef.current(confirmed);
      modal.close();
      // Reset
      resolverRef.current = null;
      setConfirmed(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmed]);

  const confirmedShow = useCallback(async (): Promise<boolean> => {
    modal.show();
    resolverRef.current = null;
    return new Promise((resolve) => {
      resolverRef.current = resolve;
    });
  }, [modal]);

  const confirmHandler = useCallback(() => {
    setConfirmed(true);
  }, []);

  return { ...modal, confirmHandler, confirmedShow };
};
